import Stats from "stats.js";

class StatsPanel {
	public readonly element: HTMLDivElement;
	private statsBoxes: Array<Stats> = [];
	/** Row holding the stats.js graphs; the info line goes underneath it. */
	private readonly boxesElement: HTMLDivElement;
	private readonly infoElement: HTMLDivElement;

	constructor() {
		this.element = this.createElement();
		this.boxesElement = this.createBoxesElement();
		this.element.appendChild(this.boxesElement);
		this.makeDraggable();
		this.createFpsStatsBox();
		this.createMemoryStatsBox();
		this.infoElement = document.createElement("div");
		this.element.appendChild(this.infoElement);
		this.hide();
	}

	/** Text under the graphs — the GPU name. Written on demand, never touched by the render loop. */
	public setInfo(text: string): void {
		this.infoElement.textContent = text;
	}

	public dispose(): void {
		this.element.remove();
	}

	private createBoxesElement(): HTMLDivElement {
		const element = document.createElement("div");
		element.style.display = "flex";
		element.style.flexDirection = "row";
		element.style.gap = "4px";
		return element;
	}

	private createElement(): HTMLDivElement {
		const element = document.createElement("div");
		element.style.zIndex = "9999";
		element.style.userSelect = "none";
		element.style.display = "flex";
		element.style.flexDirection = "column";
		element.style.gap = "2px";
		return element;
	}

	private makeDraggable(): void {
		let dragging = false;
		let offsetX = 0;
		let offsetY = 0;

		this.element.addEventListener("pointerdown", (e) => {
			dragging = true;
			offsetX = e.clientX - this.element.getBoundingClientRect().left;
			offsetY = e.clientY - this.element.getBoundingClientRect().top;
			this.element.setPointerCapture(e.pointerId);
			this.element.style.cursor = "grabbing";
		});

		this.element.addEventListener("pointermove", (e) => {
			if (dragging === false) {
				return;
			}

			const parent = this.element.parentElement;
			if (parent === null) {
				return;
			}

			const parentRect = parent.getBoundingClientRect();
			this.element.style.left = `${e.clientX - parentRect.left - offsetX}px`;
			this.element.style.top = `${e.clientY - parentRect.top - offsetY}px`;
		});

		this.element.addEventListener("pointerup", (e) => {
			dragging = false;
			this.element.releasePointerCapture(e.pointerId);
			this.element.style.cursor = "grab";
		});
	}

	private createFpsStatsBox() {
		const fpsStats = new Stats();
		fpsStats.showPanel(0);
		fpsStats.dom.style.position = "relative";
		fpsStats.dom.style.pointerEvents = "none";
		this.boxesElement.appendChild(fpsStats.dom);
		this.statsBoxes.push(fpsStats);
	}

	private createMemoryStatsBox() {
		const memoryStats = new Stats();
		memoryStats.showPanel(2);
		memoryStats.dom.style.position = "relative";
		memoryStats.dom.style.pointerEvents = "none";
		this.boxesElement.appendChild(memoryStats.dom);
		this.statsBoxes.push(memoryStats);
	}

	public show(): void {
		this.element.style.display = "flex";
	}

	public hide(): void {
		this.element.style.display = "none";
	}

	public update(): void {
		this.statsBoxes.forEach((box) => void box.update());
	}
}

export { StatsPanel };
